import * as React from 'react';

const useWindowInnerHeight = () => {
  const [windowInnerHeight, setWindowInnerHeight] = React.useState(0);

  React.useEffect(() => {
    const { innerHeight } = window;

    setWindowInnerHeight(innerHeight);

    const updateWindoInnerHeight = () => {
      setWindowInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', updateWindoInnerHeight);

    return () => {
      window.removeEventListener('resize', updateWindoInnerHeight);
    };
  }, []);

  return windowInnerHeight;
};

export default useWindowInnerHeight;
